module.exports = __webpack_public_path__ + "img/features_numbered.c60be7f9.png";